import { render, staticRenderFns } from "./editNews.vue?vue&type=template&id=0f2d433c"
import script from "./editNews.vue?vue&type=script&lang=js"
export * from "./editNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports